import * as React from 'react';
import {useEffect} from 'react';
import * as util from "../../utils/util";
import { goLoginAndReturn, goOrLogin } from "../../utils/loginRedirect";
import { resetAllStores } from "../../store/resetStores";
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import OutputRoundedIcon from '@mui/icons-material/OutputRounded';
import api from "../../utils/api";
import { notifyApiError } from "../../utils/apiError";


const MoreList = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = React.useState(false);
  
  useEffect(() => {
    setIsLogin(util.strNull(window.localStorage.userCusID) !== '' ? true : false);
  }, []);
  
  function handleClickLoginOut(){
    if(util.strNull(window.localStorage.userCusID) !== ''){ // logout
      util.clearLoginStorage();
      alert("로그아웃 되었습니다.");
      // replace — push 로 두면 뒤로가기가 방금 로그아웃한 회원 전용 화면으로 되돌아간다
      navigate('/', { replace: true });
    }else{  // move login page — 로그인 후 다시 전체메뉴로 돌아온다
      goLoginAndReturn(navigate, '/MoreMenu');
    }
  }
  
  function handleDeleteUser(){
    const userCusId = util.strNull(window.localStorage.userCusID);
    if(userCusId !== '') { // logout
      /*
      계정에 속한 회사 type 조회 후 회원 탈퇴 처리
      type B2C : 가능 => 진행
      type B2C 외 : 불가 => 미진행
      */
      const famId = (localStorage.getItem('ownerFamID') || '');
      api.get('customer/api/v2/families/' + encodeURIComponent(famId) + '/companies').then((res: any) => {
        const isPossibleWithdrawal = res.data.data.type === 'B2C';
        if(isPossibleWithdrawal){ // 회원 탈퇴 가능 여부
          if(window.confirm('정말 탈퇴하시겠습니까?')){
            api.post(`app/api/v1/AP_001_005`, { id: userCusId, email: util.strNull(window.localStorage.userID) }).then(res => {
              if(res.data.message === 'SUCCESSS'){
                alert('정상적으로 탈퇴 처리되었습니다.\n이용해주셔서 감사합니다.');
                // 탈퇴는 전체 초기화다. 저장소를 비우는 것만으로는 메모리에 남은
                // zustand 스토어가 지워지지 않아 탈퇴한 계정의 정보가 화면에 남는다.
                localStorage.clear();
                resetAllStores();
                navigate('/', { replace: true });
              }else{
                alert('탈퇴 과정에서 오류가 발생하였습니다.\n고객센터에 문의해주세요.');
              }
            }).catch(function (error) {
              notifyApiError(error, '탈퇴를 처리하지 못했습니다.');
            });
          }
        }else{
          alert('기업회원은 탈퇴할 수 없습니다.\n관리자에게 문의하세요.')
        }
      }).catch(function (error: any) {
        console.log(error)
      });

    }
  }

  const rightNavi = {
    p: '5px',

  }
  const rightNaviTitle = {
    p: 1,
    pb: 0,
    fontSize: 18,
    color: '#EF8322',
    fontWeight: 700,
    '&:hover': { bgcolor: 'transparent' }
  }
  const rightNaviMenu = {
    p: '10px 0 10px 0',
    fontSize: 16,
    fontWeight: 500,
    ml: '15px',
    '&:hover': { bgcolor: 'transparent' },
    '&:last-child': { pb: 1 }
  }
  const rightNaviout = {
    p: 1,
    fontSize: 18,
    color: '#555',
    fontWeight: 700,
    '&:hover': { bgcolor: 'transparent' },
    '&:last-child': { pb: 1 }
  }
  const RightNaviBtn = {
    border: 'none',
    p: 1,
    fontSize: 14,
    color: '#333'
  }

  
  
  return (
    <Box>
      <List disablePadding sx={rightNavi} className="rightNavi">
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle} className="rightNaviTitle">
            병원예약
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/reservation')
            }}>
            건강검진 예약
          </ListItemButton>
        </ListItem>
        
        {
          localStorage.getItem('openConsultationReservation') == 'true'
            ? 
              <ListItem disablePadding>
                <ListItemButton sx={rightNaviMenu} onClick={() => {
                    goOrLogin(navigate, '/reservationCounsel')
                  }}>
                  심리상담 예약
                </ListItemButton>
              </ListItem>
            : ''
        }
            

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/Mypage/ReservationView')
            }}>
            예약정보 확인
          </ListItemButton>
        </ListItem>
        
        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/Mypage/ReservationBeforeView')
            }}>
            검진기록 확인
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/MyPage/HealthResult')
            }}>
            건강검진 결과
          </ListItemButton>
        </ListItem>
        
        {
          localStorage.getItem('stressSurvey') == 'true'
          ?<ListItem disablePadding>
            <ListItemButton sx={rightNaviMenu} onClick={() => {
                goOrLogin(navigate, '/survey/stress')
              }}>
                직무스트레스
            </ListItemButton>
          </ListItem>
          : null
        }


        {
          localStorage.getItem('hraSurvey') == 'true'
            ? <ListItem disablePadding>
              <ListItemButton sx={rightNaviMenu} onClick={() => {
                goOrLogin(navigate, '/survey/hra')
              }}>
                뇌심혈관질환 발병위험도
              </ListItemButton>
            </ListItem>
            : null
        }


      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding>
          <Typography sx={rightNaviTitle}>
            건강 체크
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/check/Counsel')
            }}>
            상담하기
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
            navigate('../check/SelfCheckList');
          }}
          >
            자가진단
          </ListItemButton>
        </ListItem>

      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            맞춤 케어
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/care')
            }}>
            맞춤 플랜
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu}
          onClick={() => {
            navigate('../News/HealthNews');
          }}
          >
            건강 뉴스
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu}>
            <a href="https://m.blog.naver.com/dualhealth_official" title="webzine" target='_blank' style={{textDecoration:'none', color:'#000'}}>웹진(블로그) </a>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}>
            <a href="https://www.instagram.com/dualhealth_official/" title="instagram" target='_blank' style={{textDecoration:'none', color:'#000'}}>인스타그램 </a>
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            디지털 트윈
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              // 이 화면은 AP_009_002 조회에 로그인 정보(ownerFamID)가 필요하다
              goOrLogin(navigate, '/digitalTwin/modeling')
            }}>
            3D 인체 모델링
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            생활습관기록
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/history')
            }}>
            기록하기
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            공지사항
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
              goOrLogin(navigate, '/Notice/Notice')
            }}
          >
            공지사항
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
              goOrLogin(navigate, '/Notice/Event')
            }}
          >
            이벤트
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
          onClick={() => {
            navigate('../Notice/Support');
          }}
          >
            고객센터
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            약관 및 정책
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/Terms');
            }}
          >
            서비스 이용약관
          </ListItemButton>

        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/Private');
            }}
          >
            개인정보 처리방침
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={{rightNaviMenu, ml: 2, fontSize: 12}}
            onClick={() => {
              navigate('../Policy/Collect');
            }}
          >
            개인(민감)정보 수집 및 이용 동의
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={{rightNaviMenu, ml: 2, fontSize: 12}}
            onClick={() => {
              navigate('../Policy/Third');
            }}
          >
            제3자 개인정보 제공 동의(건강검진 및 심리상담)
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/UsePolicy');
            }}
          >
            건강검진 이용 및 취소/환불 규정
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/Ads');
            }}
          >
            홍보 및 마케팅 수집·이용 동의서
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            버전 및 개발
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
            navigate('../Version/Version');
          }}
          >
            버전 및 라이센스
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            마이페이지
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              goOrLogin(navigate, '/MyPage/MyPage')
            }}>
            내정보 수정
          </ListItemButton>
        </ListItem>
      </List>
      <Divider sx={{ mb: 2 }} />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding onClick={handleClickLoginOut}>
          <ListItemButton sx={rightNaviout}>
            <OutputRoundedIcon sx={{ pr: 1 }} /> {isLogin ? '로그아웃': '로그인'}
          </ListItemButton>
        </ListItem>
      </List>

      <Divider sx={{ mt: 2 }} />

      <Stack direction="row" sx={{ p: 2, fontSize: 12, display: isLogin ? 'block': 'none' }}>
        <Stack sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: 12 }} onClick={handleDeleteUser}>회원 탈퇴하기</Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default MoreList;